export default function TabLink(props: {jump_to_id: string, last_element: boolean}) {
  const jump_to_id = props.jump_to_id;
  return (
     <div 
        aria-flowto={jump_to_id}
        tabIndex={0}
         onFocus={()=>{
            let next_element = document.getElementById(jump_to_id);
            
            if (!next_element || next_element.attributes["inert"]){ return; }

            if (!next_element.attributes || !('tabindex' in next_element!.attributes)) {
               if (props.last_element){
                  let elements = next_element?.querySelectorAll("select, textarea, input, button");
                  next_element = elements[elements.length-1];
               }else{
                  next_element = next_element?.querySelector("select, textarea, input, button");
               }
            }

            if (!next_element || next_element.attributes["inert"]){ return; }
            setTimeout(() => {
                next_element.focus();
            }, 100);
        }}
      >
     </div>
  )
}

// function canFocus( element ) {
//     if ( $el.is( ":hidden" ) || $el.is( ":disabled" ) ) {
//         return false;
//     }

//     var tabIndex = +$el.attr( "tabindex" );
//     tabIndex = isNaN( tabIndex ) ? -1 : tabIndex;
//     return $el.is( ":input, a[href], area[href], iframe" ) || tabIndex > -1;
// }